import { ChatMessage } from '@aimi/models';

export class ChatConversationGet {
  static readonly type = '@ChatConversationState.get';
  constructor(public chatId: string) {}
}

export class ChatConversationReset {
  static readonly type = '@ChatConversationState.reset';
}

export class ChatConversationCreateMessage {
  static readonly type = '@ChatConversationState.createMessage';
  constructor(
    public chatId: string,
    public message: string,
  ) {}
}

export class ChatConversationAddMessage {
  static readonly type = '@ChatConversationState.addMessage';
  constructor(public chatMessage: ChatMessage) {}
}

export class ChatConversationUpdateMessage {
  static readonly type = '@ChatConversationState.updateMessage';
  constructor(public chatMessage: ChatMessage) {}
}
